export default [
  {
    name: 'Social Share',
    class: 'gf_social',
    wrap: 'gf_social',
  },
  {
    name: '(P) Title',
    class: 'gf_product-title',
    wrap: 'gf_product-title',
  },
  {
    name: '(P) File Upload',
    class: 'gf_btn-upload',
    wrap: 'gf_file-upload',
  },
  {
    name: '(P) Vendor',
    class: 'gf_product-vendor',
    wrap: 'gf_product-vendor',
  },
  {
    name: '(P) SKU',
    class: 'gf_product-sku',
    wrap: 'gf_product-sku',
  },
  {
    name: '(P) Description',
    class: 'gf_product-desc',
    wrap: 'gf_product-desc',
  },
  {
    name: '(P) Variants',
    class: 'gf_variants',
    wrap: 'gf_variants-wrapper',
  },
  {
    name: '(P) Swatches',
    class: 'gf_swatch',
    wrap: 'gf_swatches',
  },
  {
    name: '(P) Cart Button',
    class: 'gf_add-to-cart',
    wrap: 'gf_add-to-cart',
  },
  {
    name: '(P) Dynamic Checkout Button',
    class: 'shopify-payment-button__button',
    wrap: 'shopify-payment-button__button',
  },
  {
    name: '(P) View More',
    class: 'gf_view-more',
    wrap: 'gf_view-more',
  },
  {
    name: '(P) Image',
    class: 'gf_product-image',
    wrap: 'gf_product-image',
  },
  {
    name: '(P) Image List',
    class: 'gf_product-image-thumb',
    wrap: 'gf_product-images-list',
  },
  {
    name: '(P) Price',
    class: 'gf_product-price',
    wrap: 'gf_product-price',
  },
  {
    name: '(P) Quantity',
    class: 'gf_product-quantity',
    wrap: 'gf_product-quantity-selector',
  },
  {
    name: '(A) Title',
    class: 'gf_article-title',
    wrap: 'gf_article-title',
  },
  {
    name: '(A) Content',
    class: 'gf_article-content',
    wrap: 'gf_article-content',
  },
  {
    name: '(A) Excerpt',
    class: 'gf_article-excerpt',
    wrap: 'gf_article-excerpt',
  },
  {
    name: '(A) Image',
    class: 'gf_article-image',
    wrap: 'gf_article-image',
  },
  {
    name: '(A) Date',
    class: 'gf_article-date',
    wrap: 'gf_article-date',
  },
  {
    name: 'Breadcrumbs',
    class: 'gf_breadcrumbs',
    wrap: 'gf_breadcrumbs',
  },
];
